// extracted by mini-css-extract-plugin
export var smallSpinner = "_ww-0";